import { render, staticRenderFns } from "./medalDetail.vue?vue&type=template&id=58896731&scoped=true&"
import script from "./medalDetail.vue?vue&type=script&lang=js&"
export * from "./medalDetail.vue?vue&type=script&lang=js&"
import style0 from "./medalDetail.vue?vue&type=style&index=0&id=58896731&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58896731",
  null
  
)

export default component.exports